// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.music {
  --border-color: #ddd;
  --music-gap: 12px;
  --music-padding-v: 8px;
  --music-padding-h: 12px;
  --music-label-font-size: 11px;
  --music-meta-font-size: 13px;
  --music-item-font-size: 14px;
  --error-color: red;

  /* Surfaces */
  --modal-bg: #fff;
  --surface-raised: #fafafa;
  --artwork-bg: #ccc;

  /* Text hierarchy */
  --text-heading: #111;
  --text-body: #000;
  --text-label: #666;
  --text-muted: #595959;
  --text-interactive: #444;

  /* Effects */
  --header-shadow: 0 5px 5px #0000000d, 0 10px 10px #00000003;

  /* Typography */
  --modal-header-font-size: 18px;
}
.musicContainer {
  display: flex;
  flex-direction: column;
  height: 100%;

  & .listFiles {
    min-height: 0;
    flex: 1;
    overflow: hidden;
  }
}

.musicToolbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--header-gap);
  padding: var(--music-padding-v) 16px;
  border-bottom: 1px solid var(--border-color);
  flex-shrink: 0;
}

.musicToolbar-inHeader {
  padding: 0;
  border-bottom: none;
}

.musicScanLibraryButton-rescan {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: #fff;

  &:hover {
    opacity: 0.9;
  }
}

.musicScanLibraryButton:not(.button-primary) {
  background: transparent;
  border-color: transparent;
  color: var(--text-interactive);
}

.musicScanLibraryButton:not(.button-primary):hover:not(:disabled) {
  background: var(--selection-hover);
  border-color: var(--line-strong);
  opacity: 1;
}

.musicViewToggle {
  display: flex;
  border: 1px solid var(--line-strong);
  border-radius: var(--button-border-radius);
  background: var(--selection-hover);
}

.musicViewToggleButton {
  position: relative;
  padding: 5px 14px;
  color: var(--ink);
  font-size: var(--font-size-small);
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
}

.musicViewToggleButton:first-child {
  border-radius: calc(var(--button-border-radius) - 1px) 0 0
    calc(var(--button-border-radius) - 1px);
}

.musicViewToggleButton:last-child {
  border-radius: 0 calc(var(--button-border-radius) - 1px)
    calc(var(--button-border-radius) - 1px) 0;
}

.musicViewToggleButton + .musicViewToggleButton {
  border-left: 1px solid var(--line-strong);
}

.musicViewToggleButton:hover {
  color: var(--accent-strong);
}

.musicViewToggleButton:focus-visible {
  z-index: 1;
  outline: var(--outline-focus);
}

.musicViewToggleButton:active {
  z-index: 1;
  outline: var(--outline-active);
}

.musicViewToggleButton-active {
  background: var(--accent-wash);
  color: var(--accent-strong);
  box-shadow: 0 1px 2px #00000024;
}

.musicLibraryView {
  position: relative;
  user-select: none;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}

.musicImportDropOverlay {
  position: absolute;
  box-sizing: border-box;
  padding: 10px;
  background: #ffffff44;
  backdrop-filter: blur(5px);
  pointer-events: none;
  animation: fadein 120ms ease-out;
}

.musicImportDropOverlayInner {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 3px dashed var(--accent-strong);
  border-radius: 20px;
  box-shadow: 0 4px 16px #00000024;
  color: var(--ink);
  font-size: 16px;
  font-weight: 600;
}

.musicLibrarySidebarSplitter {
  flex: 1;
  min-width: 0;
  height: 100%;
  overflow: hidden;
  position: relative;
}

.musicLibrarySplitter {
  width: 100%;
  height: 100%;
  min-width: 0;
  overflow: hidden;
  position: relative;
}

.musicLibrarySplitterDropTarget {
  width: 100%;
  height: 100%;
  min-width: 0;
  position: relative;
}

.musicLibraryViewError {
  align-items: center;
  justify-content: center;
  padding: 20px;
  display: flex;
  flex: 1;
}

.musicLibraryBody {
  display: flex;
  flex-direction: row;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.musicStagingPoolBanner {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: var(--music-padding-v) var(--music-padding-h);
  border-bottom: 1px solid var(--border-color);
  background: var(--surface-raised);
  flex-shrink: 0;
}

.musicStagingPoolBannerLabel {
  font-size: var(--font-size-small);
  font-weight: 600;
  color: var(--text-heading);
  white-space: nowrap;
}

.musicBatchEditView {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.musicBatchEditHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: var(--music-padding-v) var(--music-padding-h);
  border-bottom: 1px solid var(--border-color);
  flex-shrink: 0;
}

.musicBatchEditHeaderTitle {
  margin: 0;
  font-size: var(--modal-header-font-size);
  font-weight: 600;
  color: var(--text-heading);
  font-variant-numeric: tabular-nums;
}

.musicBatchEditCloseButton {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  background: none;
  border-radius: 50%;
  cursor: pointer;

  &:hover {
    background: var(--selection-hover);
  }

  & img {
    width: 14px;
    height: 14px;
  }
}

.musicImportBatchHeaderActions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.musicImportDiscardWarning {
  font-size: var(--font-size-small);
  color: var(--text-label);
  white-space: nowrap;
}

.musicBatchEditBody {
  flex: 1;
  min-height: 0;
  position: relative;
  overflow: hidden;
}

.musicBatchEditSplitter {
  width: 100%;
  height: 100%;
  min-width: 0;
  overflow: hidden;
  position: relative;
}

.musicBatchEditSidebar {
  height: 100%;
  overflow-y: auto;
  border-left: 1px solid var(--border-color);
  background: var(--surface-raised);
}

.musicBatchEditSidebar-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--music-padding-h);
  color: var(--text-label);
  font-size: var(--font-size-small);
  text-align: center;
}

.musicBatchEditGrid {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.musicBatchEditGridHeader {
  display: grid;
  gap: var(--music-gap);
  padding: var(--music-padding-v) var(--music-padding-h);
  padding-right: calc(var(--music-padding-h) + var(--scrollbar-width));
  flex-shrink: 0;
  border-bottom: 1px solid var(--border-color);
  user-select: none;
  position: relative;
  z-index: 1;
  box-shadow: var(--header-shadow);
}

.musicBatchEditHeaderCell {
  position: relative;
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  font-size: var(--music-label-font-size);
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1px;
  opacity: 0.5;
  cursor: pointer;
}

.musicBatchEditHeaderCellText {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.musicBatchEditSortArrow {
  flex-shrink: 0;
}

.musicBatchEditGridBody {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  outline: none;
}

.musicBatchEditRow {
  box-sizing: border-box;
  display: grid;
  gap: var(--music-gap);
  padding: 0 var(--music-padding-h);
  align-items: center;
  border-bottom: 1px solid var(--border-color);

  &.selected {
    background: var(--selection-inactive);
  }
}

.musicBatchEditGridBody:focus-within .musicBatchEditRow.selected {
  background: var(--selection-active);
  color: #fff;
}

.musicBatchEditCell {
  position: relative;
  min-width: 0;
  overflow: hidden;
  font-size: var(--music-item-font-size);
  scroll-margin-inline: var(--music-gap);

  &.active {
    margin: -3px -5px;
    padding: 3px 5px;
    border-radius: 4px;
    background: var(--modal-bg);
    color: var(--text-body);
  }

  &.error {
    outline: 2px solid var(--error-color);
    outline-offset: -2px;
  }
}

.musicBatchEditGridBody:focus-within .musicBatchEditCell.active:not(.editing) {
  background: color-mix(in srgb, white, var(--selection-active) 20%);
}

.musicBatchEditCell-numeric {
  font-variant-numeric: tabular-nums;
}

.musicBatchEditRow:not(.selected) .musicBatchEditCell-readOnly {
  color: var(--muted);
}

.musicBatchEditCellText {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.musicBatchEditCellInput {
  display: block;
  width: 100%;
  box-sizing: border-box;
  border: none;
  outline: none;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  background: transparent;
}

.musicBatchEditCellInput::placeholder {
  color: var(--muted);
  font-style: italic;
}

.musicBatchEditCellSaving {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--accent);
}

.musicBatchEditColumnPopover {
  position: fixed;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 6px;
  border-radius: var(--button-border-radius);
  border: 1px solid var(--line-strong);
  background: var(--modal-bg);
  box-shadow: 0 4px 16px #00000024;
}

.musicBatchEditColumnPopoverItem {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border-radius: 3px;
  font-size: var(--music-item-font-size);
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: var(--selection-hover);
  }
}

.musicOrganizeBody {
  display: flex;
  flex-direction: row;
  gap: 16px;
  padding: 16px;
  overflow: hidden;
  background: #eeeef0;

  @media (max-width: 800px) {
    flex-direction: column;
    overflow-y: auto;
  }
}

.musicOrganizeCard,
.musicOrganizeCardPreview {
  box-sizing: border-box;
  padding: 16px;
  border: 1px solid var(--line);
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px #0000000d;
}

.musicOrganizeCard {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: none;
}

.musicOrganizeCards {
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 0 0 600px;
  max-width: 50vw;
  min-width: 0;
  overflow-y: auto;

  @media (max-width: 800px) {
    flex-basis: auto;
    max-width: none;
    overflow-y: visible;
  }
}

.musicOrganizeCardTitle {
  font-size: var(--font-size-small);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-muted);
}

.musicOrganizeCardHint {
  margin: 0;
  color: var(--text-muted);
}

.musicOrganizePresetList {
  --music-organize-choice-align: center;
  --music-organize-choice-gap: 10px;
  --music-organize-choice-padding: 8px 12px;
  --music-organize-choice-font-size: var(--music-item-font-size);
  --music-organize-choice-accent: var(--accent);
  --music-organize-choice-input-size: 14px;
  --music-organize-choice-input-margin: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: var(--text-body);
}

.musicOrganizePresetList .musicOrganizeChoiceBody {
  line-height: 1.75;
}

.musicOrganizePresetCustomLabel {
  display: flex;
  align-items: center;
}

.musicOrganizePreset {
  display: flex;
  flex-direction: column;
  border: 2px solid transparent;
  border-radius: calc(var(--button-border-radius) * 1.5);

  &:hover {
    border-color: var(--accent);
  }
}

.musicOrganizePatternSlash {
  margin-inline: 4px;
  color: var(--text-body);
}

.musicOrganizePatternPill,
.musicOrganizeTokenChip {
  background: var(--token-fill);
  color: var(--text-body);

  &[data-token='Genre'] {
    --token-fill: #fed8ca;
  }

  &[data-token='Artist'] {
    --token-fill: #ffd4e1;
  }

  &[data-token='AlbumArtist'] {
    --token-fill: #cfe3fe;
  }

  &[data-token='Album'] {
    --token-fill: #fedbab;
  }

  &[data-token='Year'] {
    --token-fill: #b5f2d2;
  }

  &[data-token='Title'] {
    --token-fill: #c5efc1;
  }

  &[data-token='Track'] {
    --token-fill: #dddefe;
  }

  &[data-token='Composer'] {
    --token-fill: #fed6d2;
  }
}

.musicOrganizePatternPill {
  padding: 3px 5px;
  border-radius: 4px;
}

.musicOrganizePatternBrace {
  color: var(--text-body);
}

.musicOrganizePatternToken {
  color: var(--text-body);
  font-weight: 600;
}

.musicOrganizePatternLiteral {
  color: var(--syntax-string);
}

.musicOrganizePresetCustom {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 12px 8px;
}

.musicOrganizePresetChevron {
  margin-left: auto;
  width: 6px;
  height: 6px;
  border-top: 2px solid var(--text-muted);
  border-right: 2px solid var(--text-muted);
  transform: rotate(45deg);
  transition: transform 0.15s;

  .musicOrganizePreset:has(input[type='radio']:checked) & {
    transform: rotate(135deg);
  }
}

.musicOrganizeTemplateInput {
  min-width: 0;
  font-size: var(--font-size-small);
  font-family: 'Roboto Mono', monospace;
  padding: 8px 10px;
  border-radius: var(--button-border-radius);
  border: 1px solid var(--line-strong);
  background: var(--modal-bg);
  color: var(--text-body);

  &:focus {
    outline: none;
    border-color: var(--accent);
    box-shadow: 0 0 0 3px var(--accent-tint);
  }
}

.musicOrganizeTokenList {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.musicOrganizeTokenChip {
  font-family: 'Roboto Mono', monospace;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: var(--button-border-radius);
  user-select: text;
}

.musicOrganizeCardPreview {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-width: 0;
  min-height: 0;
}

.musicOrganizeTree {
  flex: 1;
  min-height: 0;
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: var(--font-size-small);
  overflow-y: auto;

  @media (max-width: 800px) {
    flex: none;
    overflow-y: visible;
  }
}

.musicOrganizeTreeRow {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 3px 0 3px calc(var(--tree-depth) * 20px);
}

.musicOrganizeTreeIcon {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;
}

.musicOrganizeTreeIcon-folder {
  background: var(--accent);
  /* webpackIgnore: true */
  mask-image: url('/svg/folder.svg');
}

.musicOrganizeTreeIcon-file {
  background: var(--text-muted);
  /* webpackIgnore: true */
  mask-image: url('/svg/music.svg');
}

.musicOrganizePreviewCollision {
  font-size: var(--font-size-small);
  color: var(--error-color);
  padding: 2px 0 4px;
}

.musicOrganizePreviewNotice {
  font-size: var(--font-size-small);
  color: var(--text-muted);
  padding: 2px 0 4px;
}

.musicFilterPanels {
  display: flex;
  flex-direction: row;
  height: 100%;
  border-bottom: 1px solid var(--border-color);
  user-select: none;
}

.musicAlbumHero {
  width: 100%;
  height: 100%;
  min-height: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  overflow-y: auto;
  background: var(--surface-raised);
  border-right: 1px solid var(--border-color);
  animation: fadein 200ms ease-out;
}

.musicAlbumHeroArtwork {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  flex-shrink: 0;
  border-radius: 8px;
  overflow: hidden;
  background: var(--artwork-bg);
}

/* Highlight the hero art while an image file is dragged over it. */
.musicAlbumHeroArtwork.dragging::after {
  content: '';
  position: absolute;
  inset: 0;
  border: 3px dashed var(--accent-strong);
  border-radius: 8px;
  pointer-events: none;
}

.musicAlbumHeroArtworkDropHint {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  text-align: center;
  background: #ffffffcc;
  backdrop-filter: blur(5px);
  color: var(--ink);
  font-size: 16px;
  font-weight: 600;
  pointer-events: none;
  animation: fadein 120ms ease-out;
}

.musicAlbumHeroArtwork img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.musicAlbumHeroArtworkEdit {
  position: absolute;
  bottom: 8px;
  left: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: #000000a6;
  cursor: pointer;
  opacity: 0;
  transition: opacity 120ms ease-out;

  &:hover {
    background: #000000d9;
  }
}

.musicAlbumHeroArtwork:hover .musicAlbumHeroArtworkEdit,
.musicAlbumHeroArtworkEdit:focus-visible {
  opacity: 1;
}

.musicAlbumHeroArtworkEdit:focus-visible {
  outline: var(--outline-focus);
  outline-offset: 2px;
}

@media (hover: none) {
  .musicAlbumHeroArtworkEdit {
    opacity: 1;
  }
}

.musicAlbumHeroArtworkEditIcon {
  display: block;
  width: 20px;
  height: 20px;
  background-color: #fff;
  mask-position: center;
  mask-size: contain;
  mask-repeat: no-repeat;
  /* webpackIgnore: true */
  mask-image: url('/svg/pencil.svg');
}

.musicAlbumHeroArtworkPlaceholder {
  display: block;
  width: 100%;
  height: 100%;
  background-color: #00000059;
  mask-position: center;
  mask-size: 36%;
  mask-repeat: no-repeat;
  /* webpackIgnore: true */
  /* webpackIgnore: true */
  mask-image: url('/svg/music.svg');
}

.musicAlbumHeroBody {
  display: flex;
  flex-direction: column;
  min-width: 0;
  user-select: text;
}

.musicAlbumHeroTitle {
  margin: 0;
  font-family: var(--font-display);
  font-size: 26px;
  font-weight: 700;
  line-height: 1.15;
  letter-spacing: -0.01em;
  color: var(--ink);
}

.musicAlbumHeroArtist {
  margin-top: 8px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--accent-strong);
}

.musicAlbumHeroMeta {
  margin-top: 8px;
  font-size: var(--music-meta-font-size);
  color: var(--muted);
  font-variant-numeric: tabular-nums;
}

.musicAlbumHeroActions {
  user-select: none;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 16px;
}

.musicAlbumHeroButton {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid var(--border-color);
  background: #fff;
  color: var(--ink);
  font-size: var(--music-item-font-size);
  font-weight: 600;
  cursor: pointer;
}

.musicAlbumHeroButton img {
  width: 15px;
  height: 15px;
}

.musicAlbumHeroButton:hover {
  border-color: var(--text-muted);
}

.musicAlbumHeroButton:focus-visible {
  outline: var(--outline-focus);
  outline-offset: 2px;
}

.musicAlbumHeroButton-primary {
  background: var(--accent);
  border-color: var(--accent);
  color: #fff;
}

.musicAlbumHeroButton-primary img {
  filter: brightness(0) invert(1);
}

.musicAlbumHeroButton-primary:hover {
  background: var(--primary-color-hover);
  border-color: var(--primary-color-hover);
}

.musicAlbumHeroGenres {
  margin-top: 16px;
  font-size: var(--music-meta-font-size);
  color: var(--muted);
}

.musicFilterPanel {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative; /* Creating a stacking context. */

  & + & {
    border-left: 1px solid var(--border-color);
  }

  &:focus-within .musicFilterPanelItem.selected {
    background: var(--selection-active);
    color: #fff;
  }

  &:focus-within .musicFilterPanelItem.selected:hover {
    background: var(--selection-active-hover);
  }

  &:focus-within .musicFilterPanelItem.selected.renameTarget {
    color: transparent;
  }
}

.musicFilterPanelHeader {
  padding: var(--music-padding-v) var(--music-padding-h);
  font-size: var(--music-label-font-size);
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1px;
  opacity: 0.5;
  flex-shrink: 0;
  border-bottom: 1px solid var(--border-color);
  box-shadow: var(--header-shadow);
}

.musicFilterPanelList {
  overflow-y: auto;
  flex: 1;
  outline: none;
  padding-block: calc(var(--music-padding-h) / 2);
  font-size: var(--music-item-font-size);
}

.musicFilterPanelItem {
  padding: var(--music-padding-v) calc(var(--music-padding-h) / 2);
  margin-inline: calc(var(--music-padding-h) / 2);
  cursor: pointer;
  border-radius: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    background: var(--selection-hover);
  }

  &.selected {
    background: var(--selection-inactive);

    &:hover {
      background: var(--selection-inactive-hover);
    }
  }

  & .musicRenameInput {
    box-sizing: border-box;
    width: calc(100% + 6px);
    margin: -3px;
    padding: 3px;
    border-radius: 4px;
    background: var(--modal-bg);
    color: var(--text-body);
  }
}

.musicFilterPanelItem.selected + .musicFilterPanelItem.selected {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.musicFilterPanelItem.selected:has(+ .musicFilterPanelItem.selected) {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.musicTracksView {
  display: flex;
  flex-direction: column;
  height: 100%;
  --column-track: 24px;
}

.musicTracksHeader {
  /* Mirror .musicTrack exactly so column widths align: container padding + gap,
     no padding on individual cells. */
  display: flex;
  gap: var(--music-gap);
  padding: var(--music-padding-v) var(--music-padding-h);
  padding-right: calc(var(--music-padding-h) + var(--scrollbar-width));
  flex-shrink: 0;
  border-bottom: 1px solid var(--border-color);
  user-select: none;
  position: relative;
  z-index: 1;
  box-shadow: var(--header-shadow);
}

.musicTracksHeaderCell {
  position: relative;
  white-space: nowrap;
  font-size: var(--music-label-font-size);
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1px;
  opacity: 0.5;
}

.musicTracksHeaderTrackNumber {
  flex: 0 0 var(--column-track);
}

.musicTracksHeaderTitle {
  flex: 1;
  min-width: 100px;
  overflow: hidden;
}

.musicTracksHeaderCellText {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.musicTrackColumnResize {
  --padding: calc(var(--music-gap) / 2);
  --width: 3px;
  /* Compute the offset for half the width of this component. */
  --resize-offset: calc(-1 * var(--padding) - var(--width) / 2);
  position: absolute;
  z-index: 1;
  left: 0;

  transform: translateX(
    /* Combine the offset for this width, plus the gap */
    calc(var(--resize-offset) - var(--music-gap) / 2)
  );
  top: calc(-1 * var(--music-padding-v));
  bottom: calc(-1 * var(--music-padding-v));
  width: 3px;
  padding: 0 var(--padding);
  cursor: col-resize;
  display: flex;

  &:hover .musicTrackColResizeVisible {
    background: var(--primary-color);
  }
}

.musicTrackColumnResizeVisible {
  flex: 1;
  background: var(--border-color);
  border-radius: 1px;
}

.musicTracksContainer {
  flex: 1;
  min-height: 0;
  position: relative;
  overflow: hidden;

  &:focus-within .musicTrack.selected {
    background: var(--selection-active);
    color: #fff;

    & .musicTrackNumber img {
      filter: invert(1);
    }
  }

  &:focus-within .musicTrack.selected:hover {
    background: var(--selection-active-hover);
  }
}

.musicTracks {
  overflow-y: auto;
  outline: none;
  height: 100%;
}

.musicTrack {
  /* Height is fixed to match estimateSize in Tracks — see MusicLibraryView.tsx. */
  box-sizing: border-box;
  display: flex;
  gap: var(--music-gap);
  padding: 0 var(--music-padding-h);
  border-bottom: 1px solid var(--border-color);
  align-items: center;
  cursor: pointer;

  &:hover {
    background: var(--selection-hover);
  }

  &.selected {
    background: var(--selection-inactive);

    &:hover {
      background: var(--selection-inactive-hover);
    }
  }
}

.musicTrackNumber {
  flex: 0 0 var(--column-track);
  font-size: var(--music-item-font-size);
  font-variant-numeric: tabular-nums;
  opacity: 0.5;
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  & img {
    width: 10px;
    height: 10px;
  }
}

.musicTrackTitle {
  flex: 1;
  min-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: var(--music-item-font-size);
}

.musicTrackTitle.editing {
  overflow: visible;
  margin: -3px -5px;
  padding: 3px 5px;
  border-radius: 4px;
  background: var(--modal-bg);
  color: var(--text-body);
}

.musicRenameInput {
  display: block;
  width: 100%;
  box-sizing: border-box;
  border: none;
  outline: none;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  background: transparent;

  &::placeholder {
    color: var(--muted);
    font-style: italic;
  }
}

.musicTrackArtist {
  flex: 0 0 var(--column-artist);
  font-size: var(--music-item-font-size);
  opacity: 0.6;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.musicTrackAlbum {
  flex: 0 0 var(--column-album);
  font-size: var(--music-item-font-size);
  opacity: 0.6;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.musicPlaybackBar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  /* Match modals/menus (z-index: 1, later-in-DOM wins) so a modal opened over
     the music view still sits above the bar. */
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 16px;
  border-top: 1px solid var(--border-color);
  height: var(--playback-bar-height);
  box-sizing: border-box;
  background: var(--modal-bg);
}

.musicPlaybackArtwork {
  width: 48px;
  height: 48px;
  border-radius: 4px;
  background: var(--artwork-bg);
  flex-shrink: 0;
  overflow: hidden;
}

.musicPlaybackArtworkButton {
  padding: 0;
  border: none;
  cursor: pointer;
}

.musicPlaybackArtworkButton:disabled {
  cursor: default;
}

.musicPlaybackArtwork img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.musicPlaybackTrackInfo {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 120px;
  width: 180px;
  flex-shrink: 0;
  overflow: hidden;
}

.musicPlaybackTitle {
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.musicPlaybackArtist {
  font-size: var(--music-meta-font-size);
  opacity: 0.6;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.musicPlaybackTrackButton {
  display: block;
  min-width: 0;
  padding: 0;
  border: none;
  background: none;
  color: inherit;
  text-align: left;
  cursor: pointer;
}

.musicPlaybackTrackButton:hover {
  text-decoration: underline;
}

.musicPlaybackControls {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.musicPlaybackButtons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding-top: 5px;
}

.musicPlaybackBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  border-radius: 50%;
  opacity: 0.75;

  &:hover {
    opacity: 1;
  }
  &:disabled {
    opacity: 0.3;
    cursor: default;
  }

  & img {
    width: 22px;
    height: 22px;
  }
}

.musicPlaybackPlayBtn {
  width: 36px;
  height: 36px;
  border: 2px solid #000;
  position: relative;
  left: 1px;

  & img {
    width: 20px;
    height: 20px;
  }
}

.musicPlaybackScrubber {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.musicPlaybackTime {
  font-size: var(--music-label-font-size);
  font-variant-numeric: tabular-nums;
  opacity: 0.6;
  flex-shrink: 0;
  width: 32px;

  &:last-child {
    text-align: right;
  }
}

.musicPlaybackSeek {
  flex: 1;
  min-width: 0;
  max-width: 400px;
}

.musicPlaybackVolume {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  width: 130px;

  & img {
    width: 20px;
    height: 20px;
    opacity: 0.7;
    flex-shrink: 0;
  }
}

.musicPlaybackVolumeSlider {
  flex: 1;
  min-width: 0;
}

.musicSkeletonBar {
  height: 1em;
  border-radius: 4px;
  background: var(--border-color);
  animation: musicSkeletonPulse 2.4s ease-in-out infinite;
}

.musicAlbumHeroArtwork.musicSkeletonBar {
  height: auto;
  border-radius: 8px;
}

.musicSkeletonHeroTitle {
  height: 26px;
  width: 70%;
}

.musicSkeletonHeroMeta {
  height: 14px;
  width: 45%;
  margin-top: 12px;
}

.musicSkeletonItem {
  cursor: default;
  opacity: 0.4;
  pointer-events: none;
}

.musicSkeletonTrack {
  cursor: default;
  pointer-events: none;
  align-items: center;
}

@keyframes musicSkeletonPulse {
  50% {
    opacity: 0.5;
  }
}

.musicLoadingLabel {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  min-width: 220px;
  padding: 16px 24px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--surface-raised);
  box-shadow: var(--header-shadow);
  font-size: var(--music-item-font-size);
  color: var(--text-heading);
  animation: fadein 150ms ease-out 500ms both;
}

.musicLoadingBar {
  width: 100%;
  height: 4px;
  border-radius: 2px;
  background: var(--border-color);
  overflow: hidden;
}

.musicLoadingBarFill {
  height: 100%;
  background: var(--accent-strong);
  transition: width 150ms linear;
}

.musicLoadingBar.indeterminate .musicLoadingBarFill {
  width: 40%;
  transition: none;
  animation: musicLoadingSlide 1.4s ease-in-out infinite;
}

.musicLoadingBytes {
  font-size: var(--music-meta-font-size);
  color: var(--text-muted);
  font-variant-numeric: tabular-nums;
}

@keyframes musicLoadingSlide {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(250%);
  }
}

:where(.musicOrganizeChoiceList) {
  --music-organize-choice-align: flex-start;
  --music-organize-choice-gap: 8px;
  --music-organize-choice-padding: 6px 12px;
  --music-organize-choice-font-size: var(--music-item-font-size);
  --music-organize-choice-accent: var(--accent);
  --music-organize-choice-input-size: 14px;
  --music-organize-choice-input-margin: 4px 0 0;
}

.musicOrganizeChoice {
  display: flex;
  align-items: var(--music-organize-choice-align);
  gap: var(--music-organize-choice-gap);
  padding: var(--music-organize-choice-padding);
  font-size: var(--music-organize-choice-font-size);
  cursor: pointer;

  & input {
    flex-shrink: 0;
    width: var(--music-organize-choice-input-size);
    height: var(--music-organize-choice-input-size);
    margin: var(--music-organize-choice-input-margin);
    accent-color: var(--music-organize-choice-accent);
  }
}

.musicOrganizeChoiceBody {
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
}

.musicOrganizeQuality {
  display: flex;
  flex-direction: column;
  gap: 16px;

  & p {
    margin: 0;
  }
}

.musicOrganizeQualitySide {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.musicOrganizeQualityInfo {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 20px;
  font-size: var(--music-item-font-size);
  border: 1px solid var(--line-strong);
  border-radius: calc(var(--button-border-radius) * 1.5);
}

.musicOrganizeFormatGroup {
  --music-organize-choice-padding: 4px 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 16px;

  & legend {
    float: left;
    padding: 0;
    line-height: 2;
  }
}

.musicOrganizeQualityGroup {
  border: none;
  margin: 0;
  padding: 0;
  min-width: 0;
}

.musicOrganizeQualityLabel {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 16px;
}

.musicOrganizeQualityName {
  font-weight: 600;
}

.musicOrganizeQualityDetail {
  color: var(--text-muted);
  font-size: var(--music-meta-font-size);
}

.musicOrganizeQualityHow {
  color: var(--text-muted);
  font-size: var(--music-meta-font-size);
  margin: 0;
  padding-left: 20px;

  & li + li {
    margin-top: 4px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/Music/index.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;EAC5B,kBAAkB;;EAElB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;;EAElB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;;EAExB,YAAY;EACZ,2DAA2D;;EAE3D,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;;EAEZ;IACE,aAAa;IACb,OAAO;IACP,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,oCAAoC;EACpC,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,WAAW;;EAEX;IACE,YAAY;EACd;AACF;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE;2CACyC;AAC3C;;AAEA;EACE;6CAC2C;AAC7C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,qBAAqB;EACrB,0BAA0B;EAC1B,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,sDAAsD;EACtD,4CAA4C;EAC5C,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,sDAAsD;EACtD,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,wCAAwC;EACxC,gBAAgB;EAChB,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;;EAEf;IACE,kCAAkC;EACpC;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,wBAAwB;EACxB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,sDAAsD;EACtD,oEAAoE;EACpE,cAAc;EACd,4CAA4C;EAC5C,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,uCAAuC;EACvC,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,qBAAqB;EACrB,iCAAiC;EACjC,mBAAmB;EACnB,4CAA4C;;EAE5C;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,sCAAsC;EACtC,sCAAsC;;EAEtC;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;IACrC,oBAAoB;EACtB;AACF;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,UAAU;EACV,SAAS;EACT,aAAa;EACb,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,0CAA0C;EAC1C,oCAAoC;EACpC,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;EACf,mBAAmB;;EAEnB;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,mBAAmB;;EAEnB;IACE,sBAAsB;IACtB,gBAAgB;EAClB;AACF;;AAEA;;EAEE,sBAAsB;EACtB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,eAAe;EACf,YAAY;EACZ,gBAAgB;;EAEhB;IACE,gBAAgB;IAChB,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,yCAAyC;EACzC,8DAA8D;EAC9D,6CAA6C;EAC7C,wCAAwC;EACxC,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,sDAAsD;;EAEtD;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;;EAEE,6BAA6B;EAC7B,uBAAuB;;EAEvB;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,uCAAuC;EACvC,yCAAyC;EACzC,wBAAwB;EACxB,2BAA2B;;EAE3B;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,YAAY;EACZ,iCAAiC;EACjC,qCAAqC;EACrC,iBAAiB;EACjB,0CAA0C;EAC1C,oCAAoC;EACpC,2BAA2B;EAC3B,uBAAuB;;EAEvB;IACE,aAAa;IACb,2BAA2B;IAC3B,wCAAwC;EAC1C;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,OAAO;EACP,aAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;;EAEhB;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,iCAAiC;EACjC,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,mEAAmE;AACnE;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,uCAAuC;EACvC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,UAAU;EACV,kCAAkC;;EAElC;IACE,qBAAqB;EACvB;AACF;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,qBAAqB;EACrB,cAAc;EACd,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB,EAAE,iCAAiC;;EAErD;IACE,0CAA0C;EAC5C;;EAEA;IACE,mCAAmC;IACnC,WAAW;EACb;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,sDAAsD;EACtD,uCAAuC;EACvC,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,OAAO;EACP,aAAa;EACb,+CAA+C;EAC/C,sCAAsC;AACxC;;AAEA;EACE,gEAAgE;EAChE,+CAA+C;EAC/C,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;;EAEvB;IACE,kCAAkC;EACpC;;EAEA;IACE,qCAAqC;;IAErC;MACE,2CAA2C;IAC7C;EACF;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,uBAAuB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE;sCACoC;EACpC,aAAa;EACb,qBAAqB;EACrB,sDAAsD;EACtD,oEAAoE;EACpE,cAAc;EACd,4CAA4C;EAC5C,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;EACvC,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,6DAA6D;EAC7D,6DAA6D;EAC7D,kBAAkB;EAClB,UAAU;EACV,OAAO;;EAEP;;;GAGC;EACD,sCAAsC;EACtC,yCAAyC;EACzC,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;;EAEb;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,OAAO;EACP,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,kBAAkB;EAClB,gBAAgB;;EAEhB;IACE,mCAAmC;IACnC,WAAW;;IAEX;MACE,iBAAiB;IACnB;EACF;;EAEA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gFAAgF;EAChF,sBAAsB;EACtB,aAAa;EACb,qBAAqB;EACrB,iCAAiC;EACjC,4CAA4C;EAC5C,mBAAmB;EACnB,eAAe;;EAEf;IACE,kCAAkC;EACpC;;EAEA;IACE,qCAAqC;;IAErC;MACE,2CAA2C;IAC7C;EACF;AACF;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,kCAAkC;EAClC,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;;EAEzB;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,UAAU;EACV,SAAS;EACT,aAAa;EACb,cAAc;EACd,uBAAuB;;EAEvB;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,SAAS;EACT;+CAC6C;EAC7C,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,yCAAyC;EACzC,kCAAkC;EAClC,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,aAAa;;EAEb;IACE,UAAU;EACZ;EACA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;;EAET;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,uCAAuC;EACvC,kCAAkC;EAClC,YAAY;EACZ,cAAc;EACd,WAAW;;EAEX;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,YAAY;;EAEZ;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,cAAc;EAChB;AACF;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,uDAAuD;AACzD;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,sCAAsC;EACtC,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,yCAAyC;EACzC,gCAAgC;EAChC,yCAAyC;EACzC,8DAA8D;EAC9D,6CAA6C;EAC7C,wCAAwC;EACxC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,qCAAqC;EACrC,6CAA6C;EAC7C,iDAAiD;EACjD,eAAe;;EAEf;IACE,cAAc;IACd,8CAA8C;IAC9C,+CAA+C;IAC/C,iDAAiD;IACjD,iDAAiD;EACnD;AACF;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET;IACE,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,sCAAsC;EACtC,oCAAoC;EACpC,sDAAsD;AACxD;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;;EAEb;IACE,WAAW;IACX,UAAU;IACV,cAAc;EAChB;AACF;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,SAAS;EACT,kBAAkB;;EAElB;IACE,eAAe;EACjB;AACF","sourcesContent":[".music {\n  --border-color: #ddd;\n  --music-gap: 12px;\n  --music-padding-v: 8px;\n  --music-padding-h: 12px;\n  --music-label-font-size: 11px;\n  --music-meta-font-size: 13px;\n  --music-item-font-size: 14px;\n  --error-color: red;\n\n  /* Surfaces */\n  --modal-bg: #fff;\n  --surface-raised: #fafafa;\n  --artwork-bg: #ccc;\n\n  /* Text hierarchy */\n  --text-heading: #111;\n  --text-body: #000;\n  --text-label: #666;\n  --text-muted: #595959;\n  --text-interactive: #444;\n\n  /* Effects */\n  --header-shadow: 0 5px 5px #0000000d, 0 10px 10px #00000003;\n\n  /* Typography */\n  --modal-header-font-size: 18px;\n}\n.musicContainer {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n\n  & .listFiles {\n    min-height: 0;\n    flex: 1;\n    overflow: hidden;\n  }\n}\n\n.musicToolbar {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: var(--header-gap);\n  padding: var(--music-padding-v) 16px;\n  border-bottom: 1px solid var(--border-color);\n  flex-shrink: 0;\n}\n\n.musicToolbar-inHeader {\n  padding: 0;\n  border-bottom: none;\n}\n\n.musicScanLibraryButton-rescan {\n  background: var(--primary-color);\n  border-color: var(--primary-color);\n  color: #fff;\n\n  &:hover {\n    opacity: 0.9;\n  }\n}\n\n.musicScanLibraryButton:not(.button-primary) {\n  background: transparent;\n  border-color: transparent;\n  color: var(--text-interactive);\n}\n\n.musicScanLibraryButton:not(.button-primary):hover:not(:disabled) {\n  background: var(--selection-hover);\n  border-color: var(--line-strong);\n  opacity: 1;\n}\n\n.musicViewToggle {\n  display: flex;\n  border: 1px solid var(--line-strong);\n  border-radius: var(--button-border-radius);\n  background: var(--selection-hover);\n}\n\n.musicViewToggleButton {\n  position: relative;\n  padding: 5px 14px;\n  color: var(--ink);\n  font-size: var(--font-size-small);\n  font-weight: 500;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.musicViewToggleButton:first-child {\n  border-radius: calc(var(--button-border-radius) - 1px) 0 0\n    calc(var(--button-border-radius) - 1px);\n}\n\n.musicViewToggleButton:last-child {\n  border-radius: 0 calc(var(--button-border-radius) - 1px)\n    calc(var(--button-border-radius) - 1px) 0;\n}\n\n.musicViewToggleButton + .musicViewToggleButton {\n  border-left: 1px solid var(--line-strong);\n}\n\n.musicViewToggleButton:hover {\n  color: var(--accent-strong);\n}\n\n.musicViewToggleButton:focus-visible {\n  z-index: 1;\n  outline: var(--outline-focus);\n}\n\n.musicViewToggleButton:active {\n  z-index: 1;\n  outline: var(--outline-active);\n}\n\n.musicViewToggleButton-active {\n  background: var(--accent-wash);\n  color: var(--accent-strong);\n  box-shadow: 0 1px 2px #00000024;\n}\n\n.musicLibraryView {\n  position: relative;\n  user-select: none;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow: hidden;\n}\n\n.musicImportDropOverlay {\n  position: absolute;\n  box-sizing: border-box;\n  padding: 10px;\n  background: #ffffff44;\n  backdrop-filter: blur(5px);\n  pointer-events: none;\n  animation: fadein 120ms ease-out;\n}\n\n.musicImportDropOverlayInner {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 3px dashed var(--accent-strong);\n  border-radius: 20px;\n  box-shadow: 0 4px 16px #00000024;\n  color: var(--ink);\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.musicLibrarySidebarSplitter {\n  flex: 1;\n  min-width: 0;\n  height: 100%;\n  overflow: hidden;\n  position: relative;\n}\n\n.musicLibrarySplitter {\n  width: 100%;\n  height: 100%;\n  min-width: 0;\n  overflow: hidden;\n  position: relative;\n}\n\n.musicLibrarySplitterDropTarget {\n  width: 100%;\n  height: 100%;\n  min-width: 0;\n  position: relative;\n}\n\n.musicLibraryViewError {\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  display: flex;\n  flex: 1;\n}\n\n.musicLibraryBody {\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.musicStagingPoolBanner {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: var(--music-padding-v) var(--music-padding-h);\n  border-bottom: 1px solid var(--border-color);\n  background: var(--surface-raised);\n  flex-shrink: 0;\n}\n\n.musicStagingPoolBannerLabel {\n  font-size: var(--font-size-small);\n  font-weight: 600;\n  color: var(--text-heading);\n  white-space: nowrap;\n}\n\n.musicBatchEditView {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.musicBatchEditHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: var(--music-padding-v) var(--music-padding-h);\n  border-bottom: 1px solid var(--border-color);\n  flex-shrink: 0;\n}\n\n.musicBatchEditHeaderTitle {\n  margin: 0;\n  font-size: var(--modal-header-font-size);\n  font-weight: 600;\n  color: var(--text-heading);\n  font-variant-numeric: tabular-nums;\n}\n\n.musicBatchEditCloseButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: none;\n  background: none;\n  border-radius: 50%;\n  cursor: pointer;\n\n  &:hover {\n    background: var(--selection-hover);\n  }\n\n  & img {\n    width: 14px;\n    height: 14px;\n  }\n}\n\n.musicImportBatchHeaderActions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.musicImportDiscardWarning {\n  font-size: var(--font-size-small);\n  color: var(--text-label);\n  white-space: nowrap;\n}\n\n.musicBatchEditBody {\n  flex: 1;\n  min-height: 0;\n  position: relative;\n  overflow: hidden;\n}\n\n.musicBatchEditSplitter {\n  width: 100%;\n  height: 100%;\n  min-width: 0;\n  overflow: hidden;\n  position: relative;\n}\n\n.musicBatchEditSidebar {\n  height: 100%;\n  overflow-y: auto;\n  border-left: 1px solid var(--border-color);\n  background: var(--surface-raised);\n}\n\n.musicBatchEditSidebar-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--music-padding-h);\n  color: var(--text-label);\n  font-size: var(--font-size-small);\n  text-align: center;\n}\n\n.musicBatchEditGrid {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.musicBatchEditGridHeader {\n  display: grid;\n  gap: var(--music-gap);\n  padding: var(--music-padding-v) var(--music-padding-h);\n  padding-right: calc(var(--music-padding-h) + var(--scrollbar-width));\n  flex-shrink: 0;\n  border-bottom: 1px solid var(--border-color);\n  user-select: none;\n  position: relative;\n  z-index: 1;\n  box-shadow: var(--header-shadow);\n}\n\n.musicBatchEditHeaderCell {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  min-width: 0;\n  font-size: var(--music-label-font-size);\n  font-weight: bold;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  opacity: 0.5;\n  cursor: pointer;\n}\n\n.musicBatchEditHeaderCellText {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.musicBatchEditSortArrow {\n  flex-shrink: 0;\n}\n\n.musicBatchEditGridBody {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  outline: none;\n}\n\n.musicBatchEditRow {\n  box-sizing: border-box;\n  display: grid;\n  gap: var(--music-gap);\n  padding: 0 var(--music-padding-h);\n  align-items: center;\n  border-bottom: 1px solid var(--border-color);\n\n  &.selected {\n    background: var(--selection-inactive);\n  }\n}\n\n.musicBatchEditGridBody:focus-within .musicBatchEditRow.selected {\n  background: var(--selection-active);\n  color: #fff;\n}\n\n.musicBatchEditCell {\n  position: relative;\n  min-width: 0;\n  overflow: hidden;\n  font-size: var(--music-item-font-size);\n  scroll-margin-inline: var(--music-gap);\n\n  &.active {\n    margin: -3px -5px;\n    padding: 3px 5px;\n    border-radius: 4px;\n    background: var(--modal-bg);\n    color: var(--text-body);\n  }\n\n  &.error {\n    outline: 2px solid var(--error-color);\n    outline-offset: -2px;\n  }\n}\n\n.musicBatchEditGridBody:focus-within .musicBatchEditCell.active:not(.editing) {\n  background: color-mix(in srgb, white, var(--selection-active) 20%);\n}\n\n.musicBatchEditCell-numeric {\n  font-variant-numeric: tabular-nums;\n}\n\n.musicBatchEditRow:not(.selected) .musicBatchEditCell-readOnly {\n  color: var(--muted);\n}\n\n.musicBatchEditCellText {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.musicBatchEditCellInput {\n  display: block;\n  width: 100%;\n  box-sizing: border-box;\n  border: none;\n  outline: none;\n  padding: 0;\n  margin: 0;\n  font: inherit;\n  color: inherit;\n  background: transparent;\n}\n\n.musicBatchEditCellInput::placeholder {\n  color: var(--muted);\n  font-style: italic;\n}\n\n.musicBatchEditCellSaving {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--accent);\n}\n\n.musicBatchEditColumnPopover {\n  position: fixed;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 6px;\n  border-radius: var(--button-border-radius);\n  border: 1px solid var(--line-strong);\n  background: var(--modal-bg);\n  box-shadow: 0 4px 16px #00000024;\n}\n\n.musicBatchEditColumnPopoverItem {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 8px;\n  border-radius: 3px;\n  font-size: var(--music-item-font-size);\n  cursor: pointer;\n  white-space: nowrap;\n\n  &:hover {\n    background: var(--selection-hover);\n  }\n}\n\n.musicOrganizeBody {\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  padding: 16px;\n  overflow: hidden;\n  background: #eeeef0;\n\n  @media (max-width: 800px) {\n    flex-direction: column;\n    overflow-y: auto;\n  }\n}\n\n.musicOrganizeCard,\n.musicOrganizeCardPreview {\n  box-sizing: border-box;\n  padding: 16px;\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 1px 3px #0000000d;\n}\n\n.musicOrganizeCard {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  flex: none;\n}\n\n.musicOrganizeCards {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  flex: 0 0 600px;\n  max-width: 50vw;\n  min-width: 0;\n  overflow-y: auto;\n\n  @media (max-width: 800px) {\n    flex-basis: auto;\n    max-width: none;\n    overflow-y: visible;\n  }\n}\n\n.musicOrganizeCardTitle {\n  font-size: var(--font-size-small);\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--text-muted);\n}\n\n.musicOrganizeCardHint {\n  margin: 0;\n  color: var(--text-muted);\n}\n\n.musicOrganizePresetList {\n  --music-organize-choice-align: center;\n  --music-organize-choice-gap: 10px;\n  --music-organize-choice-padding: 8px 12px;\n  --music-organize-choice-font-size: var(--music-item-font-size);\n  --music-organize-choice-accent: var(--accent);\n  --music-organize-choice-input-size: 14px;\n  --music-organize-choice-input-margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  color: var(--text-body);\n}\n\n.musicOrganizePresetList .musicOrganizeChoiceBody {\n  line-height: 1.75;\n}\n\n.musicOrganizePresetCustomLabel {\n  display: flex;\n  align-items: center;\n}\n\n.musicOrganizePreset {\n  display: flex;\n  flex-direction: column;\n  border: 2px solid transparent;\n  border-radius: calc(var(--button-border-radius) * 1.5);\n\n  &:hover {\n    border-color: var(--accent);\n  }\n}\n\n.musicOrganizePatternSlash {\n  margin-inline: 4px;\n  color: var(--text-body);\n}\n\n.musicOrganizePatternPill,\n.musicOrganizeTokenChip {\n  background: var(--token-fill);\n  color: var(--text-body);\n\n  &[data-token='Genre'] {\n    --token-fill: #fed8ca;\n  }\n\n  &[data-token='Artist'] {\n    --token-fill: #ffd4e1;\n  }\n\n  &[data-token='AlbumArtist'] {\n    --token-fill: #cfe3fe;\n  }\n\n  &[data-token='Album'] {\n    --token-fill: #fedbab;\n  }\n\n  &[data-token='Year'] {\n    --token-fill: #b5f2d2;\n  }\n\n  &[data-token='Title'] {\n    --token-fill: #c5efc1;\n  }\n\n  &[data-token='Track'] {\n    --token-fill: #dddefe;\n  }\n\n  &[data-token='Composer'] {\n    --token-fill: #fed6d2;\n  }\n}\n\n.musicOrganizePatternPill {\n  padding: 3px 5px;\n  border-radius: 4px;\n}\n\n.musicOrganizePatternBrace {\n  color: var(--text-body);\n}\n\n.musicOrganizePatternToken {\n  color: var(--text-body);\n  font-weight: 600;\n}\n\n.musicOrganizePatternLiteral {\n  color: var(--syntax-string);\n}\n\n.musicOrganizePresetCustom {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 0 12px 8px;\n}\n\n.musicOrganizePresetChevron {\n  margin-left: auto;\n  width: 6px;\n  height: 6px;\n  border-top: 2px solid var(--text-muted);\n  border-right: 2px solid var(--text-muted);\n  transform: rotate(45deg);\n  transition: transform 0.15s;\n\n  .musicOrganizePreset:has(input[type='radio']:checked) & {\n    transform: rotate(135deg);\n  }\n}\n\n.musicOrganizeTemplateInput {\n  min-width: 0;\n  font-size: var(--font-size-small);\n  font-family: 'Roboto Mono', monospace;\n  padding: 8px 10px;\n  border-radius: var(--button-border-radius);\n  border: 1px solid var(--line-strong);\n  background: var(--modal-bg);\n  color: var(--text-body);\n\n  &:focus {\n    outline: none;\n    border-color: var(--accent);\n    box-shadow: 0 0 0 3px var(--accent-tint);\n  }\n}\n\n.musicOrganizeTokenList {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.musicOrganizeTokenChip {\n  font-family: 'Roboto Mono', monospace;\n  font-size: 12px;\n  padding: 2px 8px;\n  border-radius: var(--button-border-radius);\n  user-select: text;\n}\n\n.musicOrganizeCardPreview {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex: 1;\n  min-width: 0;\n  min-height: 0;\n}\n\n.musicOrganizeTree {\n  flex: 1;\n  min-height: 0;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  font-size: var(--font-size-small);\n  overflow-y: auto;\n\n  @media (max-width: 800px) {\n    flex: none;\n    overflow-y: visible;\n  }\n}\n\n.musicOrganizeTreeRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 3px 0 3px calc(var(--tree-depth) * 20px);\n}\n\n.musicOrganizeTreeIcon {\n  flex-shrink: 0;\n  width: 16px;\n  height: 16px;\n  mask-size: contain;\n  mask-repeat: no-repeat;\n  mask-position: center;\n}\n\n.musicOrganizeTreeIcon-folder {\n  background: var(--accent);\n  /* webpackIgnore: true */\n  mask-image: url('/svg/folder.svg');\n}\n\n.musicOrganizeTreeIcon-file {\n  background: var(--text-muted);\n  /* webpackIgnore: true */\n  mask-image: url('/svg/music.svg');\n}\n\n.musicOrganizePreviewCollision {\n  font-size: var(--font-size-small);\n  color: var(--error-color);\n  padding: 2px 0 4px;\n}\n\n.musicOrganizePreviewNotice {\n  font-size: var(--font-size-small);\n  color: var(--text-muted);\n  padding: 2px 0 4px;\n}\n\n.musicFilterPanels {\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n  border-bottom: 1px solid var(--border-color);\n  user-select: none;\n}\n\n.musicAlbumHero {\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 20px;\n  overflow-y: auto;\n  background: var(--surface-raised);\n  border-right: 1px solid var(--border-color);\n  animation: fadein 200ms ease-out;\n}\n\n.musicAlbumHeroArtwork {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 1 / 1;\n  flex-shrink: 0;\n  border-radius: 8px;\n  overflow: hidden;\n  background: var(--artwork-bg);\n}\n\n/* Highlight the hero art while an image file is dragged over it. */\n.musicAlbumHeroArtwork.dragging::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  border: 3px dashed var(--accent-strong);\n  border-radius: 8px;\n  pointer-events: none;\n}\n\n.musicAlbumHeroArtworkDropHint {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px;\n  text-align: center;\n  background: #ffffffcc;\n  backdrop-filter: blur(5px);\n  color: var(--ink);\n  font-size: 16px;\n  font-weight: 600;\n  pointer-events: none;\n  animation: fadein 120ms ease-out;\n}\n\n.musicAlbumHeroArtwork img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.musicAlbumHeroArtworkEdit {\n  position: absolute;\n  bottom: 8px;\n  left: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: none;\n  border-radius: 50%;\n  background: #000000a6;\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity 120ms ease-out;\n\n  &:hover {\n    background: #000000d9;\n  }\n}\n\n.musicAlbumHeroArtwork:hover .musicAlbumHeroArtworkEdit,\n.musicAlbumHeroArtworkEdit:focus-visible {\n  opacity: 1;\n}\n\n.musicAlbumHeroArtworkEdit:focus-visible {\n  outline: var(--outline-focus);\n  outline-offset: 2px;\n}\n\n@media (hover: none) {\n  .musicAlbumHeroArtworkEdit {\n    opacity: 1;\n  }\n}\n\n.musicAlbumHeroArtworkEditIcon {\n  display: block;\n  width: 20px;\n  height: 20px;\n  background-color: #fff;\n  mask-position: center;\n  mask-size: contain;\n  mask-repeat: no-repeat;\n  /* webpackIgnore: true */\n  mask-image: url('/svg/pencil.svg');\n}\n\n.musicAlbumHeroArtworkPlaceholder {\n  display: block;\n  width: 100%;\n  height: 100%;\n  background-color: #00000059;\n  mask-position: center;\n  mask-size: 36%;\n  mask-repeat: no-repeat;\n  /* webpackIgnore: true */\n  /* webpackIgnore: true */\n  mask-image: url('/svg/music.svg');\n}\n\n.musicAlbumHeroBody {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  user-select: text;\n}\n\n.musicAlbumHeroTitle {\n  margin: 0;\n  font-family: var(--font-display);\n  font-size: 26px;\n  font-weight: 700;\n  line-height: 1.15;\n  letter-spacing: -0.01em;\n  color: var(--ink);\n}\n\n.musicAlbumHeroArtist {\n  margin-top: 8px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--accent-strong);\n}\n\n.musicAlbumHeroMeta {\n  margin-top: 8px;\n  font-size: var(--music-meta-font-size);\n  color: var(--muted);\n  font-variant-numeric: tabular-nums;\n}\n\n.musicAlbumHeroActions {\n  user-select: none;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 16px;\n}\n\n.musicAlbumHeroButton {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 8px 16px;\n  border-radius: 8px;\n  border: 1px solid var(--border-color);\n  background: #fff;\n  color: var(--ink);\n  font-size: var(--music-item-font-size);\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.musicAlbumHeroButton img {\n  width: 15px;\n  height: 15px;\n}\n\n.musicAlbumHeroButton:hover {\n  border-color: var(--text-muted);\n}\n\n.musicAlbumHeroButton:focus-visible {\n  outline: var(--outline-focus);\n  outline-offset: 2px;\n}\n\n.musicAlbumHeroButton-primary {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: #fff;\n}\n\n.musicAlbumHeroButton-primary img {\n  filter: brightness(0) invert(1);\n}\n\n.musicAlbumHeroButton-primary:hover {\n  background: var(--primary-color-hover);\n  border-color: var(--primary-color-hover);\n}\n\n.musicAlbumHeroGenres {\n  margin-top: 16px;\n  font-size: var(--music-meta-font-size);\n  color: var(--muted);\n}\n\n.musicFilterPanel {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  position: relative; /* Creating a stacking context. */\n\n  & + & {\n    border-left: 1px solid var(--border-color);\n  }\n\n  &:focus-within .musicFilterPanelItem.selected {\n    background: var(--selection-active);\n    color: #fff;\n  }\n\n  &:focus-within .musicFilterPanelItem.selected:hover {\n    background: var(--selection-active-hover);\n  }\n\n  &:focus-within .musicFilterPanelItem.selected.renameTarget {\n    color: transparent;\n  }\n}\n\n.musicFilterPanelHeader {\n  padding: var(--music-padding-v) var(--music-padding-h);\n  font-size: var(--music-label-font-size);\n  font-weight: bold;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  opacity: 0.5;\n  flex-shrink: 0;\n  border-bottom: 1px solid var(--border-color);\n  box-shadow: var(--header-shadow);\n}\n\n.musicFilterPanelList {\n  overflow-y: auto;\n  flex: 1;\n  outline: none;\n  padding-block: calc(var(--music-padding-h) / 2);\n  font-size: var(--music-item-font-size);\n}\n\n.musicFilterPanelItem {\n  padding: var(--music-padding-v) calc(var(--music-padding-h) / 2);\n  margin-inline: calc(var(--music-padding-h) / 2);\n  cursor: pointer;\n  border-radius: 3px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  &:hover {\n    background: var(--selection-hover);\n  }\n\n  &.selected {\n    background: var(--selection-inactive);\n\n    &:hover {\n      background: var(--selection-inactive-hover);\n    }\n  }\n\n  & .musicRenameInput {\n    box-sizing: border-box;\n    width: calc(100% + 6px);\n    margin: -3px;\n    padding: 3px;\n    border-radius: 4px;\n    background: var(--modal-bg);\n    color: var(--text-body);\n  }\n}\n\n.musicFilterPanelItem.selected + .musicFilterPanelItem.selected {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.musicFilterPanelItem.selected:has(+ .musicFilterPanelItem.selected) {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.musicTracksView {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  --column-track: 24px;\n}\n\n.musicTracksHeader {\n  /* Mirror .musicTrack exactly so column widths align: container padding + gap,\n     no padding on individual cells. */\n  display: flex;\n  gap: var(--music-gap);\n  padding: var(--music-padding-v) var(--music-padding-h);\n  padding-right: calc(var(--music-padding-h) + var(--scrollbar-width));\n  flex-shrink: 0;\n  border-bottom: 1px solid var(--border-color);\n  user-select: none;\n  position: relative;\n  z-index: 1;\n  box-shadow: var(--header-shadow);\n}\n\n.musicTracksHeaderCell {\n  position: relative;\n  white-space: nowrap;\n  font-size: var(--music-label-font-size);\n  font-weight: bold;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  opacity: 0.5;\n}\n\n.musicTracksHeaderTrackNumber {\n  flex: 0 0 var(--column-track);\n}\n\n.musicTracksHeaderTitle {\n  flex: 1;\n  min-width: 100px;\n  overflow: hidden;\n}\n\n.musicTracksHeaderCellText {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.musicTrackColumnResize {\n  --padding: calc(var(--music-gap) / 2);\n  --width: 3px;\n  /* Compute the offset for half the width of this component. */\n  --resize-offset: calc(-1 * var(--padding) - var(--width) / 2);\n  position: absolute;\n  z-index: 1;\n  left: 0;\n\n  transform: translateX(\n    /* Combine the offset for this width, plus the gap */\n    calc(var(--resize-offset) - var(--music-gap) / 2)\n  );\n  top: calc(-1 * var(--music-padding-v));\n  bottom: calc(-1 * var(--music-padding-v));\n  width: 3px;\n  padding: 0 var(--padding);\n  cursor: col-resize;\n  display: flex;\n\n  &:hover .musicTrackColResizeVisible {\n    background: var(--primary-color);\n  }\n}\n\n.musicTrackColumnResizeVisible {\n  flex: 1;\n  background: var(--border-color);\n  border-radius: 1px;\n}\n\n.musicTracksContainer {\n  flex: 1;\n  min-height: 0;\n  position: relative;\n  overflow: hidden;\n\n  &:focus-within .musicTrack.selected {\n    background: var(--selection-active);\n    color: #fff;\n\n    & .musicTrackNumber img {\n      filter: invert(1);\n    }\n  }\n\n  &:focus-within .musicTrack.selected:hover {\n    background: var(--selection-active-hover);\n  }\n}\n\n.musicTracks {\n  overflow-y: auto;\n  outline: none;\n  height: 100%;\n}\n\n.musicTrack {\n  /* Height is fixed to match estimateSize in Tracks — see MusicLibraryView.tsx. */\n  box-sizing: border-box;\n  display: flex;\n  gap: var(--music-gap);\n  padding: 0 var(--music-padding-h);\n  border-bottom: 1px solid var(--border-color);\n  align-items: center;\n  cursor: pointer;\n\n  &:hover {\n    background: var(--selection-hover);\n  }\n\n  &.selected {\n    background: var(--selection-inactive);\n\n    &:hover {\n      background: var(--selection-inactive-hover);\n    }\n  }\n}\n\n.musicTrackNumber {\n  flex: 0 0 var(--column-track);\n  font-size: var(--music-item-font-size);\n  font-variant-numeric: tabular-nums;\n  opacity: 0.5;\n  text-align: right;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n\n  & img {\n    width: 10px;\n    height: 10px;\n  }\n}\n\n.musicTrackTitle {\n  flex: 1;\n  min-width: 100px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: var(--music-item-font-size);\n}\n\n.musicTrackTitle.editing {\n  overflow: visible;\n  margin: -3px -5px;\n  padding: 3px 5px;\n  border-radius: 4px;\n  background: var(--modal-bg);\n  color: var(--text-body);\n}\n\n.musicRenameInput {\n  display: block;\n  width: 100%;\n  box-sizing: border-box;\n  border: none;\n  outline: none;\n  padding: 0;\n  margin: 0;\n  font: inherit;\n  color: inherit;\n  background: transparent;\n\n  &::placeholder {\n    color: var(--muted);\n    font-style: italic;\n  }\n}\n\n.musicTrackArtist {\n  flex: 0 0 var(--column-artist);\n  font-size: var(--music-item-font-size);\n  opacity: 0.6;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.musicTrackAlbum {\n  flex: 0 0 var(--column-album);\n  font-size: var(--music-item-font-size);\n  opacity: 0.6;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.musicPlaybackBar {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  /* Match modals/menus (z-index: 1, later-in-DOM wins) so a modal opened over\n     the music view still sits above the bar. */\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 8px 16px;\n  border-top: 1px solid var(--border-color);\n  height: var(--playback-bar-height);\n  box-sizing: border-box;\n  background: var(--modal-bg);\n}\n\n.musicPlaybackArtwork {\n  width: 48px;\n  height: 48px;\n  border-radius: 4px;\n  background: var(--artwork-bg);\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.musicPlaybackArtworkButton {\n  padding: 0;\n  border: none;\n  cursor: pointer;\n}\n\n.musicPlaybackArtworkButton:disabled {\n  cursor: default;\n}\n\n.musicPlaybackArtwork img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.musicPlaybackTrackInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 120px;\n  width: 180px;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.musicPlaybackTitle {\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.musicPlaybackArtist {\n  font-size: var(--music-meta-font-size);\n  opacity: 0.6;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.musicPlaybackTrackButton {\n  display: block;\n  min-width: 0;\n  padding: 0;\n  border: none;\n  background: none;\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.musicPlaybackTrackButton:hover {\n  text-decoration: underline;\n}\n\n.musicPlaybackControls {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.musicPlaybackButtons {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding-top: 5px;\n}\n\n.musicPlaybackBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: none;\n  background: none;\n  cursor: pointer;\n  border-radius: 50%;\n  opacity: 0.75;\n\n  &:hover {\n    opacity: 1;\n  }\n  &:disabled {\n    opacity: 0.3;\n    cursor: default;\n  }\n\n  & img {\n    width: 22px;\n    height: 22px;\n  }\n}\n\n.musicPlaybackPlayBtn {\n  width: 36px;\n  height: 36px;\n  border: 2px solid #000;\n  position: relative;\n  left: 1px;\n\n  & img {\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.musicPlaybackScrubber {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.musicPlaybackTime {\n  font-size: var(--music-label-font-size);\n  font-variant-numeric: tabular-nums;\n  opacity: 0.6;\n  flex-shrink: 0;\n  width: 32px;\n\n  &:last-child {\n    text-align: right;\n  }\n}\n\n.musicPlaybackSeek {\n  flex: 1;\n  min-width: 0;\n  max-width: 400px;\n}\n\n.musicPlaybackVolume {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n  width: 130px;\n\n  & img {\n    width: 20px;\n    height: 20px;\n    opacity: 0.7;\n    flex-shrink: 0;\n  }\n}\n\n.musicPlaybackVolumeSlider {\n  flex: 1;\n  min-width: 0;\n}\n\n.musicSkeletonBar {\n  height: 1em;\n  border-radius: 4px;\n  background: var(--border-color);\n  animation: musicSkeletonPulse 2.4s ease-in-out infinite;\n}\n\n.musicAlbumHeroArtwork.musicSkeletonBar {\n  height: auto;\n  border-radius: 8px;\n}\n\n.musicSkeletonHeroTitle {\n  height: 26px;\n  width: 70%;\n}\n\n.musicSkeletonHeroMeta {\n  height: 14px;\n  width: 45%;\n  margin-top: 12px;\n}\n\n.musicSkeletonItem {\n  cursor: default;\n  opacity: 0.4;\n  pointer-events: none;\n}\n\n.musicSkeletonTrack {\n  cursor: default;\n  pointer-events: none;\n  align-items: center;\n}\n\n@keyframes musicSkeletonPulse {\n  50% {\n    opacity: 0.5;\n  }\n}\n\n.musicLoadingLabel {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 1;\n  transform: translate(-50%, -50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  min-width: 220px;\n  padding: 16px 24px;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  background: var(--surface-raised);\n  box-shadow: var(--header-shadow);\n  font-size: var(--music-item-font-size);\n  color: var(--text-heading);\n  animation: fadein 150ms ease-out 500ms both;\n}\n\n.musicLoadingBar {\n  width: 100%;\n  height: 4px;\n  border-radius: 2px;\n  background: var(--border-color);\n  overflow: hidden;\n}\n\n.musicLoadingBarFill {\n  height: 100%;\n  background: var(--accent-strong);\n  transition: width 150ms linear;\n}\n\n.musicLoadingBar.indeterminate .musicLoadingBarFill {\n  width: 40%;\n  transition: none;\n  animation: musicLoadingSlide 1.4s ease-in-out infinite;\n}\n\n.musicLoadingBytes {\n  font-size: var(--music-meta-font-size);\n  color: var(--text-muted);\n  font-variant-numeric: tabular-nums;\n}\n\n@keyframes musicLoadingSlide {\n  from {\n    transform: translateX(-100%);\n  }\n  to {\n    transform: translateX(250%);\n  }\n}\n\n:where(.musicOrganizeChoiceList) {\n  --music-organize-choice-align: flex-start;\n  --music-organize-choice-gap: 8px;\n  --music-organize-choice-padding: 6px 12px;\n  --music-organize-choice-font-size: var(--music-item-font-size);\n  --music-organize-choice-accent: var(--accent);\n  --music-organize-choice-input-size: 14px;\n  --music-organize-choice-input-margin: 4px 0 0;\n}\n\n.musicOrganizeChoice {\n  display: flex;\n  align-items: var(--music-organize-choice-align);\n  gap: var(--music-organize-choice-gap);\n  padding: var(--music-organize-choice-padding);\n  font-size: var(--music-organize-choice-font-size);\n  cursor: pointer;\n\n  & input {\n    flex-shrink: 0;\n    width: var(--music-organize-choice-input-size);\n    height: var(--music-organize-choice-input-size);\n    margin: var(--music-organize-choice-input-margin);\n    accent-color: var(--music-organize-choice-accent);\n  }\n}\n\n.musicOrganizeChoiceBody {\n  flex: 1;\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.musicOrganizeQuality {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  & p {\n    margin: 0;\n  }\n}\n\n.musicOrganizeQualitySide {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.musicOrganizeQualityInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px 20px;\n  font-size: var(--music-item-font-size);\n  border: 1px solid var(--line-strong);\n  border-radius: calc(var(--button-border-radius) * 1.5);\n}\n\n.musicOrganizeFormatGroup {\n  --music-organize-choice-padding: 4px 0;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px 16px;\n\n  & legend {\n    float: left;\n    padding: 0;\n    line-height: 2;\n  }\n}\n\n.musicOrganizeQualityGroup {\n  border: none;\n  margin: 0;\n  padding: 0;\n  min-width: 0;\n}\n\n.musicOrganizeQualityLabel {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.musicOrganizeQualityName {\n  font-weight: 600;\n}\n\n.musicOrganizeQualityDetail {\n  color: var(--text-muted);\n  font-size: var(--music-meta-font-size);\n}\n\n.musicOrganizeQualityHow {\n  color: var(--text-muted);\n  font-size: var(--music-meta-font-size);\n  margin: 0;\n  padding-left: 20px;\n\n  & li + li {\n    margin-top: 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
